import apiClient from "services/apiClient";

async function addCondition(data: any) {
  const url = `/admin/conditions`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addCondition;
